import { VoiceCallContext } from "@contexts/voiceCallContext";
import { useContext } from "react";

const CallCountdownTimer = () => {
    const { time, showTimer } = useContext(VoiceCallContext)

    return (
        <span>
            {
                time && showTimer &&
                    ` ${time.minutes
                    .toString()
                    .padStart(2, '0')}:${time.seconds.toString().padStart(2, '0')}`
                    
                // add show hours
                // {`${time.hours.toString().padStart(2, '0')}:`}
            }
        </span>
    );
}

export default CallCountdownTimer
